<div class="ncp-login">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left Section: Text Content -->
      <div class="col-lg-6 col-md-12">
        <div class="ncp-login__content">
          <h1 class="ncp-login__title">{{translations.welcome}}</h1>
          <p class="ncp-login__description">
            {{environment.project === PROJECTS.PROVIDERS ? translations.text_providers : translations.text_beneficiaries}}
          </p>
          <button
            type="button"
            class="btn btn-primary btn-lg ncp-login__login-button"
            (click)="doLogin()"
          >
            {{translations.login}}
          </button>
        </div>
      </div>

      <!-- Right Section: Image Placeholder -->
      <div class="col-lg-6 col-md-12">
        <div class="ncp-login__image-container">
          <img
            [src]="heroImagePath"
            alt="Healthcare professional using digital health platform"
            class="ncp-login__hero-image"
          />
        </div>
      </div>
    </div>
  </div>
</div>
